import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["element-loading-text"]
const _hoisted_2 = { style: {"color":"red"} }
const _hoisted_3 = { style: {"color":"red"} }
const _hoisted_4 = { style: {"align":"right"} }
const _hoisted_5 = { class: "vo-ft-pry" }
const _hoisted_6 = { class: "vo-ft-pry" }
const _hoisted_7 = { class: "vo-ft-pry" }
const _hoisted_8 = { class: "vo-ft-pry" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("审批中")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("待支付")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("已支付")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("异常")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("退回")

import { onMounted , ref, reactive, unref } from 'vue';
import { ElMessage } from 'element-plus';
import { useUser } from '@/store/user.store';
import { formatTools, RmbcCpital } from '@/utils';
import { useCtCategory } from '@/store/category.store';
import { useDictionary } from '@/store/dictionary.store';
import BillMaterialList from './billmateriallist.vue';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';

import { PayPlanDetailApi, BillMaterialApi } from '@/apis/PayPlans/payplan.api';
import { nextTick } from 'process';


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { fAmount, fDateTime } = formatTools();

// 获取翻译函数
const { t } = useLocales();

const billmateriallistRef = ref<InstanceType<typeof BillMaterialList>>(); // 附件

const userStore = useUser();
const catStory = useCtCategory();
const { getName } = useDictionary();


const state = reactive({
	show: false,
	title: t('billDetail.title', '付款单列表'),
	loading: false,
	tabActive: 0,
	detail: {} as any,
});

const load = {
	/* 获取付款计划明细 */
	getDetail: (planId: string) => {
		state.tabActive = 0;
		state.loading = true;
		PayPlanDetailApi(planId)
			.then((res) => {
				if (!res.succeeded) {
					ElMessage.error(`读取付款计划出错，可能的原因是：${res.errors}。`);
				} else {
					console.log('付款计划', res.data),
					state.detail = res.data;
					nextTick(() => {
						console.log(unref(billmateriallistRef))
						// 添加空值检查
						const billMaterialListRef = unref(billmateriallistRef);
						if (billMaterialListRef && state.detail.bill_list && state.detail.bill_list[state.tabActive]) {
							billMaterialListRef.setFileList(state.detail.bill_list[state.tabActive].id);
						}
					});
				}
			})
			.finally(() => {
				state.loading = false;
			});
	},
};

const actions = {
	tabChange: () => {
		console.log(state.tabActive)
		// 添加空值检查
		const billMaterialListRef = unref(billmateriallistRef);
		if (billMaterialListRef && state.detail.bill_list && state.detail.bill_list[state.tabActive]) {
			billMaterialListRef.setFileList(state.detail.bill_list[state.tabActive].id);
		}
	}
}

const expFuncs = {
	openDialog: (planId: string) => {
		load.getDetail(planId);
		state.show = true;
	},
};

expose({ ...expFuncs });

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    width: "860"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('billDetail.buttons.close', '关闭')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        "element-loading-text": _unref(t)('billDetail.loading', '正在获取数据，请稍后')
      }, [
        _createVNode(_component_el_descriptions, {
          column: 3,
          border: true,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.contractNo', '合同编号'),
              "label-align": "center",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail?.contract_no || '--'), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.contractName', '合同名称'),
              "label-align": "center",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail?.contract_name || '--'), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.contractCategory', '合同类别'),
              "label-align": "center",
              span: "5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(catStory).getName(_unref(state).detail?.contract_type)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.ourParty', '我方主体'),
              "label-align": "center",
              span: "5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail?.party_a), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.planName', '款项名称'),
              "label-align": "center",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail?.name), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.planCondition', '款项条件'),
              "label-align": "center",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail?.pay_condition), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.planAmount', '款项金额'),
              "label-align": "center",
              span: "1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(state).detail?.amount?.toLocaleString()), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.unpayAmount', '未付金额'),
              "label-align": "center",
              span: "2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString((_unref(state).detail?.unpay_amt || 0).toLocaleString()), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _unref(t)('billDetail.contractInfo.remark', '备注'),
              "label-align": "center",
              span: "3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(state).detail?.remark), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider),
        ((_unref(state).detail?.bill_list || []).length > 0)
          ? (_openBlock(), _createBlock(_component_el_tabs, {
              key: 0,
              modelValue: _unref(state).tabActive,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).tabActive) = $event)),
              onTabChange: actions.tabChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).detail?.bill_list, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                    key: item.id,
                    label: item.bill_no,
                    name: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_unref(t)('billDetail.billInfo.kingdeeType', '金蝶单据类型')) + "： ", 1),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getName)('kingdee_type',item.kingdee_type) || _unref(t)('billDetail.billInfo.paymentApply', '付款申请')), 1),
                        _createTextVNode(" ，" + _toDisplayString(_unref(t)('billDetail.billInfo.kingdeeApplyNo', '金蝶申请单号')) + "： ", 1),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.kingdee_apply_no || _unref(t)('billDetail.billInfo.notReturned', '未返回')), 1),
                        _createTextVNode(" ，" + _toDisplayString(_unref(t)('billDetail.billInfo.erpBillNo', '金蝶付款申请单号')) + "： ", 1),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.erp_bill_no || _unref(t)('billDetail.billInfo.notReturned', '未返回')), 1),
                        _createTextVNode(" ， " + _toDisplayString(_unref(t)('billDetail.billInfo.kindeePayNo', '付款单号')) + "： ", 1),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(item.kindee_pay_no || _unref(t)('billDetail.billInfo.notReturned', '未返回')), 1)
                      ]),
                      _createVNode(_component_el_descriptions, {
                        border: "",
                        size: "small",
                        style: {"margin-top":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.applicant', '申请人')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.sub_emp_name || '--'), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.applicantDept', '申请部门')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.sub_emp_dept), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.applyTime', '申请时间')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(fDateTime)(item.sub_date)), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.applyAmount', '申请金额')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(fAmount)(item.amount)), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.amountInWords', '金额大写')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(RmbcCpital)(item.amount)), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.applyType', '申请类型')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tag, { size: "small" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.oa_pay_name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.payeeType', '收款单位类型')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tag, { size: "small" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.oa_shou_type_name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.paymentPurpose', '收付款用途')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tag, { size: "small" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.pay_type), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.settlementMethod', '结算方式')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tag, { size: "small" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(getName)('pay_method',item.pay_method)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.expenseItem', '费用项目')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tag, { size: "small" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(getName)('pay_item',item.pay_item)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.invoiceNo', '发票号码')
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.invoice_no), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.approvalStatus', '审批状态')
                          }, {
                            default: _withCtx(() => [
                              (item.pay_status == 1)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    size: "small",
                                    type: "warning"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (item.pay_status == 2)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 1,
                                    size: "small",
                                    type: "primary"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_10
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (item.pay_status == 3)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 2,
                                    size: "small",
                                    type: "success"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (item.pay_status == 4)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 3,
                                    size: "small",
                                    type: "danger"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_12
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (item.pay_status == 5)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 4,
                                    size: "small",
                                    type: "info"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_13
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.paymentRemark', '付款备注'),
                            span: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.pay_remark), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.accountName', '户名'),
                            span: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.bank_account_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.account', '账户'),
                            span: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.bank_account), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.bankName', '银行名称'),
                            span: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.bank_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.bankAddress', '银行地址'),
                            span: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.bank_address), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.countersignApprover', '会签批核人'),
                            span: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select_v2, {
                                class: "w100",
                                modelValue: item.sign_list,
                                "onUpdate:modelValue": ($event: any) => ((item.sign_list) = $event),
                                options: _unref(userStore).getSelectList(),
                                placeholder: "会签人员",
                                "tag-type": "primary",
                                multiple: "",
                                disabled: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                            ]),
                            _: 2
                          }, 1032, ["label"]),
                          _createVNode(_component_el_descriptions_item, {
                            label: _unref(t)('billDetail.billInfo.executionApprover', '执行批核人'),
                            span: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select_v2, {
                                class: "w100",
                                modelValue: item.receive_list,
                                "onUpdate:modelValue": ($event: any) => ((item.receive_list) = $event),
                                options: _unref(userStore).getSelectList(),
                                placeholder: "执行人员",
                                "tag-type": "primary",
                                multiple: "",
                                disabled: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                            ]),
                            _: 2
                          }, 1032, ["label"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["label", "name"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onTabChange"]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: _unref(t)('billDetail.empty', '这里并没有付款单，也许你需要通知你的同事是时候履约合同了')
            }, null, 8, ["description"])),
        _createVNode(_component_el_divider, { "content-position": 'center' }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('billDetail.attachmentTitle', '付款申请附件')), 1)
          ]),
          _: 1
        }),
        _createVNode(BillMaterialList, {
          ref_key: "billmateriallistRef",
          ref: billmateriallistRef
        }, null, 512)
      ], 8, _hoisted_1)), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})